import { render, staticRenderFns } from "./setPersonnel.vue?vue&type=template&id=fba52972&"
import script from "./setPersonnel.vue?vue&type=script&lang=js&"
export * from "./setPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./setPersonnel.vue?vue&type=style&index=0&id=fba52972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports